export default __webpack_public_path__ + "static/media/lifeleech2.d03794fd.png";